/* unplugin-vue-components disabled */import { render } from "./sh-files.vue?vue&type=template&id=7035fabb&scoped=true"
import script from "./sh-files.vue?vue&type=script&setup=true&lang=js"
export * from "./sh-files.vue?vue&type=script&setup=true&lang=js"

import "./sh-files.vue?vue&type=style&index=0&id=7035fabb&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7035fabb"],['__file',"src/pages/sh-files/sh-files.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7035fabb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7035fabb', __exports__)) {
    api.reload('7035fabb', __exports__)
  }
  
  module.hot.accept("./sh-files.vue?vue&type=template&id=7035fabb&scoped=true", () => {
    api.rerender('7035fabb', render)
  })

}


export default __exports__